import {
  Component,
  ViewEncapsulation,
  OnInit, Inject, OnDestroy, ViewChild, AfterViewInit
} from '@angular/core';
import {
  State
} from '@progress/kendo-data-query';
import {
  DataStateChangeEvent,
  GridDataResult,
  RowArgs, SelectionEvent
} from '@progress/kendo-angular-grid';

import {ActivatedRoute, Router} from '@angular/router';
import {UserContext} from '../../../../services/user-context/user-context';
import {ConfirmDialogComponent} from '../../../../shared/layout/components/confirm-dialog/confirm-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import {ApiService} from '../../../../services/api/api.service';
import {DOCUMENT} from '@angular/common';
import {Observable, Subscription} from 'rxjs';
import {WaiverDialogComponent} from './waiver-dialog.component';
import {WaiversService} from './waivers.service';

@Component({
  selector: 'app-waivers',
  encapsulation: ViewEncapsulation.None,
  templateUrl: 'waivers.template.html'
})
export class WaiversComponent implements OnInit, OnDestroy {

  public view: Observable<GridDataResult>;
  public subscription: Subscription;
  private selectedWaiver: RowArgs;
  public state: State = {
    skip: 0,
    take: 10
  };

  loading = false;
  public crumbs: any[] = [
    {label: 'Accounts', link: '/accounts'}
  ];

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    public dialog: MatDialog,
    private service: WaiversService,
    private api: ApiService,
    private snackBar: MatSnackBar,
    private userContext: UserContext,
    @Inject(DOCUMENT) private document: Document) {

  }

  public ngOnInit(): void {
    this.view = this.service;
    this.subscription = this.service.subscription;

    this.getWaivers();
  }

  public ngOnDestroy(): void {

  }

  public dataWaiverStateChange(state: DataStateChangeEvent): void {
    this.state = state;
    this.getWaivers();
  }

  public getWaivers() {
    const page = this.state.skip / this.state.take + 1;
    const limit = this.state.take;

    this.service.getWaivers(page, limit, () => {
      this.loading = false;
    });
  }


  public onWaiverSelection(event: SelectionEvent) {
    this.selectedWaiver = event.selectedRows[0];
  }

  public addWaiver(): void {
    const dialogRef = this.dialog.open(WaiverDialogComponent, {
      width: '700px'
    });

    dialogRef.afterClosed().subscribe(waiver => {

      if ( waiver ) {
        waiver.account = this.userContext.account.id;
        this.api.post<any>(`/account/${waiver.account}/waiver`, waiver ).subscribe( result => {
          this.snackBar.open('Waiver added.', null, {
            duration: 2000
          });
          this.getWaivers();
        }, (error) => {
          this.snackBar.open(`Error adding waiver: ${error}`, null, {
            duration: 2000
          });
        });
      }
    });
  }

  public editWaiver(): void {
    const dialogRef = this.dialog.open(WaiverDialogComponent, {
      width: '700px',
      data: this.selectedWaiver.dataItem
    });

    dialogRef.afterClosed().subscribe(waiver => {

      if ( waiver ) {
        this.api.patch<any>(`/waiver/${waiver.id}`, waiver).subscribe( result => {
          this.snackBar.open('Waiver updated.', null, {
            duration: 2000
          });
          this.getWaivers();
        }, (error) => {
          this.snackBar.open(`Error updating waiver: ${error}`, null, {
            duration: 2000
          });
        });
      }

      this.selectedWaiver = null;
    });
  }

  public removeWaiver(): void {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '300px',
      data: { message: 'Remove this waiver?', action: 'Remove'}
    });

    dialogRef.afterClosed().subscribe(confirmed => {
      if ( confirmed ) {
        this.api.del<any>(`/waiver/${this.selectedWaiver.dataItem._id}` ).subscribe( result => {
          this.snackBar.open('Waiver removed.', null, {
            duration: 2000
          });
          this.getWaivers();
        }, (error) => {
          this.snackBar.open(`Error removing waiver: ${error}`, null, {
            duration: 2000
          });
        });
      }
      this.selectedWaiver = null;
    });
  }

}
